import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get, api_post } from "api/utils"
import { CursorType } from "utils/types"
import { IdentityProps } from 'stores/identity_store';

export type TeamType = {
    key: string;
    uuid: string;
    identity: string;
    name: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: TeamType) => void;
};

// Domain object Team
export class Team implements TeamType {
    key = "";
    uuid = "";
    identity = "";
    name = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: TeamType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: TeamType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class TeamStore extends BaseStore<TeamType, Team> {


    async supportFetchTeam(uuid: string) {
        // Autogenerated
        const response = await api_get(`/team?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }

    async fetchMyTeam(identity: string) {
        const response = await api_get('/team/', { identity }); // trailing slash needed
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }

    async createTeam(identity: string, name: string) {
        const data = { identity, name };
        const response = await api_post("/team/create", data);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }

    /* This will have a top limit of 50 (due to team_blueprint.py)
     * Feel free to fix that so it works with the cursor.
     *  - We can probably load these via identityStore a cursor,
     *  - Then check to see team.uuid
     *  - It should work
     */
    async fetchIdentityList(identity: string, team: string, cursor?: CursorType): Promise<IdentityProps[]>  {
        const url = '/team/list/identities';
        const data = { identity, team, cursor: cursor || '' };
        const response = await api_get(url, data);
        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data.items);
            // ignore the cursor since we can't page through results here.
            // if(data?.cursor) {
            //     this.fetchIdentityList(identity, team, data.cursor);
            // }
            return data.items;
        }
        return [];
    };


    modelConstructor() {
        return Team;
    }

}
